// extracted by mini-css-extract-plugin
export var allNewsItemsLink = "news-module--allNewsItemsLink--A4RK4";
export var left = "news-module--left--LaFsC";
export var marginTop = "news-module--marginTop--Co-+S";
export var news = "news-module--news--FOeoQ";
export var right = "news-module--right--J7oLw";